import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GraphicReportsService } from '../../graphic-reports.service';
import { SharedService } from '@myproject/shared/shared.service';
import { DatePipe } from '@angular/common';
import * as FileSaver from 'file-saver';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';
import { GroupsService } from '@myproject/components/device/groups/groups.service';
import { configMessage } from '@shared/config-message';

@Component({
    selector: 'app-not-communicating-report',
    templateUrl: './not-communicating-report.component.html',
    styleUrls: ['./not-communicating-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotCommunicatingReportComponent implements OnInit {
  page = 0;
  // isLoading = false;
  startTime: number;
  endTime: number;
  timeZone: string;
  dateRange: string;
  selectedStartTime: number;
  selectedEndTime: number;
  devices: any[] = [];
  pieChart: any;
  lineChart: any;
  selectedCategory = '';
  displayCategory = '';
  selectedType = '';
  resetOffset = false;
  hideCalendar = false;
  blockCall = false;
  highestCount = 0;
  colors: any = [];
  searchableData = [];
  searchedData = [];
  searchValue = '';
  searchPopup = false;
  isLoading = {
    firmwarePie: true,
    trendData: true,
    devices: true
  };

  groups: any = [];
  configMessage = configMessage;
  selectedDate: any = {};
  displayTitle: any = {};
  selectedGroupId = 'All';
  selectedDateDeviceCount: number;

  constructor(
    private reportsService: GraphicReportsService,
    private sharedService: SharedService,
    private title: Title,
    private groupsService: GroupsService
  ) { }

  ngOnInit() {
    Chart.register(...registerables);
    this.title.setTitle('Not Communicating'+ environment.title_text);
    this.getGroups();
  }

  onTimeChange(e) {
    if (e) {
      this.startTime = e.startTime;
      this.endTime = e.endTime;
      this.dateRange = e.dateRange;
    }
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.page = 0;
    this.resetOffset = !this.resetOffset;
    if (this.groups.length) {
      this.resetSearch();
      //this.getAllNotCommCount(e.startTime, e.endTime, this.selectedCategory);
      this.getNotCommTrendData(this.startTime, this.endTime, 'groupName', this.displayCategory, '#F6B01D', this.timeZone, this.dateRange);
      this.getAllNotCommDevices(this.startTime, this.endTime, 0, this.timeZone);
    }
  }

  onPageChange(page) {
    this.page = page;
    this.getAllNotCommDevices(this.startTime, this.endTime, page, this.timeZone);
  }

  onCategoryChange(key, display) {
    this.selectedCategory = key;
    this.displayCategory = display;
    this.blockCall = false;
    this.resetSearch();
    this.getAllNotCommCount(this.startTime, this.endTime, key, this.timeZone);
  }

  onCategorySearch() {
    const global = this;
    this.searchedData =  this.searchableData.filter(function(item) {
      return item.category.toLowerCase().includes(global.searchValue.toLowerCase());
    });
  }

  showSearchPopup() {
    this.searchValue = '';
    this.searchedData = this.searchableData;
    this.searchPopup = true;
  }

  onSelectCategory(item: {category: '', color: '', name: '', groupId: ''}) {
    this.displayCategory = item.name;
    this.selectedType = item.category;
    this.searchPopup = false;
    this.searchValue = '';
    this.selectedGroupId = item.name;
    this.getNotCommTrendData(this.startTime, this.endTime, this.selectedCategory, item.name, "#F6B01D", this.timeZone, this.dateRange);
    this.getAllNotCommDevices(this.startTime, this.endTime, 0, this.timeZone);
  }

  resetSearch() {
    this.searchValue = '';
    this.searchableData = [];
    this.searchedData = [];
    this.searchPopup = false;
    this.isLoading.firmwarePie = true;
    this.isLoading.trendData = true;
  }

  refresh() {
    this.page = 0;
    this.resetOffset = !this.resetOffset;
    this.resetSearch();
    this.getAllNotCommCount(this.startTime, this.endTime, this.selectedCategory, this.timeZone);
    this.getAllNotCommDevices(this.startTime, this.endTime, 0, this.timeZone);
  }

  getAllNotCommCount(startTime, endTime, type, timeZone) {
    this.isLoading.firmwarePie = true;
    this.reportsService.getAllNotCommCount(startTime, endTime, type, timeZone).subscribe({
      next: res => {
        this.isLoading.firmwarePie = false;
        if (res.length) {
          res.map(item => {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            const color = 'rgb(' + r + ',' + g + ',' + b + ')';
            const obj = { category: item.type, color: color };
            this.searchableData.push(obj);
            this.colors.push(color);
          });
          this.selectedType = res[0].type;
          this.getNotCommTrendData(this.startTime, this.endTime, type, res[0].type, '#F6B01D', timeZone, this.dateRange);
          this.drawPieGraph(res);
        } else {
          this.drawPieGraph([]);
          this.drawLineGraph([], '');
          this.isLoading.trendData = false;
        }
      },
      error: error => {
        this.isLoading.firmwarePie = false;
        this.isLoading.trendData = false;
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  getNotCommTrendData(startTime, endTime, type, value, color, timeZone, dateRange) {
    this.isLoading.trendData = true;
    this.reportsService.getNotCommTrendData(startTime, endTime, type, value, timeZone, dateRange).subscribe({
      next: res => {
        this.isLoading.trendData = false;
        if (res.length) {
          if (value === "All") {
            let sumCounts = this.sumCountsByDay(res);
            let combinedRes = [];
            let tempRes = {};
            tempRes["type"] = "All";
            tempRes["data"] = sumCounts;
            combinedRes.push(tempRes);
            this.drawLineGraph(combinedRes, color);
          } else {
            this.drawLineGraph(res, color);
          }
        } else {
          this.drawLineGraph([], '');
        }
      },
      error: error => {
        this.isLoading.trendData = false;
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  getAllNotCommDevices(startTime, endTime, page, timeZone) {
    this.isLoading.devices = true;

    this.selectedDate = new Date(endTime);
    if (endTime - startTime >= 86400000 && this.dateRange !== "Custom")  {
      this.selectedDate.setDate(this.selectedDate.getDate() - 1);
    }
    this.selectedDate.setHours(0);
    this.selectedDate.setMinutes(0);
    this.selectedDate.setSeconds(0);
    this.selectedDate.setMilliseconds(0);
    const datePipe = new DatePipe('en-US');
    const eventDate = datePipe.transform(this.selectedDate, 'dd MMM yyyy');
    this.selectedStartTime = this.selectedDate.getTime() + (this.selectedDate.getTimezoneOffset() * -1 * 60 * 1000);
    this.selectedEndTime = this.selectedStartTime;

    this.reportsService.getAllNotCommDevices(this.selectedStartTime, this.selectedEndTime, this.selectedGroupId, page, timeZone).subscribe({
      next: res => {
        this.isLoading.devices = false;
        if (!res.length) { this.blockCall = true; }
        if (page === 0) {
          this.devices = res;
        } else {
          this.devices = [...this.devices, ...res];
        }
      },
      error: error => {
        this.isLoading.devices = false;
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  downloadAllNotCommDevices(attributes) {
    this.reportsService.downloadAllNotCommDevices(this.selectedStartTime, this.selectedEndTime, this.selectedGroupId, attributes, this.timeZone).subscribe({
      next: res => {
        const contentDisposition = res.headers.get('Content-Disposition');
        let filename;
        if (contentDisposition == null) {
          // const date = new Date();
          // filename = 'Device_' + date + '.zip';
          const decoder = new TextDecoder('utf-8');
          const text = decoder.decode(res.body);
          const responseMessage = { success: true, message: text };
          this.sharedService.setResponseMessage(responseMessage);
        } else {
          filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
          const blob = new Blob([res.body], {
            type: 'application/zip'
          });
          FileSaver.saveAs(blob, filename);
        }
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  drawPieGraph(data) {
    if (this.pieChart) {
      this.pieChart.destroy();
    }
    const global = this;
    const labels = [];
    const counts = [];
    data.map(item => {
      labels.push(item.type);
      counts.push(item.count);
    });
    var ctx = document.getElementById('pieChart') as HTMLCanvasElement;
    this.pieChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [{
          data: counts,
          backgroundColor: global.colors,
          borderColor: global.colors
        }]
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          position: 'bottom',
          display: false,
          },
        },
        scales: {
          x: {
            display: false,
            beginAtZero: true,
          },
          y: {
            display: false,
            stacked: true,
            beginAtZero: true,
          }
        },
        onClick: (event, elements, chart) => {
          if (!elements.length) return;
          const { datasetIndex, index } = elements[0];
          const dataset = chart.data.datasets[datasetIndex];
          const label = (dataset.label ?? chart.data.labels[index]) as string;
          const bgColor = Array.isArray(dataset.backgroundColor) ? dataset.backgroundColor[index] : dataset.backgroundColor;
          this.selectedType = label;
          this.getNotCommTrendData(
            this.startTime,
            this.endTime,
            this.selectedCategory,
            label,
            bgColor,
            this.timeZone,
            this.dateRange
          );
        }
      }
    });
  }

  drawLineGraph(res, color) {
    if (this.lineChart) {
      this.lineChart.destroy();
    }
    this.highestCount = 0;
    const labels = [];
    const dataset = [];
    const highestCountsArray = [];
    if (res.length) {
      res[0].data.map(item => {
        const datePipe = new DatePipe('en-US');
        const eventDate = datePipe.transform(item.day, 'dd MMM yyyy', 'UTC');
        labels.push(eventDate);
      });
      this.displayTitle = "Not Communicating Devices as on " + labels[labels.length - 1];
      this.selectedDateDeviceCount = res[0].data[res[0].data.length - 1].count;
      res.map((item, index) => {
        const obj: any = {};
        const counts = [];
        item.data.map(innerItem => {
          counts.push(innerItem.count);
        });
        highestCountsArray.push(Math.max(...counts));
        obj.label = item.type;
        obj.data = counts;
        obj.backgroundColor = color;
        obj.borderColor = color;
        obj.fill = false;
        dataset.push(obj);
      });
      this.highestCount = Math.max(...highestCountsArray);
    }
    var ctx = document.getElementById('lineChart') as HTMLCanvasElement;
    this.lineChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: dataset
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          position: 'right',
          display: false,
          },
        },
        scales: {
          x: {
            display: true,
            beginAtZero: true,
          },
          y: {
            display: true,
            stacked: false,
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 10,
            ticks: {
              stepSize: this.highestCount > 9 ? null : 1
            }
          }
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const firstElement = elements[0];
            const label = this.lineChart.data.labels[firstElement.index];
            const value = this.lineChart.data.datasets[firstElement.datasetIndex].data[firstElement.index];

            // Convert the label to a Date object if necessary
            const date = new Date(label);
            this.displayTitle = "Not Communicating Devices as on " + label;
            this.selectedDateDeviceCount = value;
            this.getAllNotCommDevices(date.getTime(), date.getTime(), 0, this.timeZone);
          }
        },
        onHover: (event, elements) => {
          const target = event.native ? (event.native as any).target as HTMLElement : null;
          if (elements.length > 0) {
            if (target) target.style.cursor = 'pointer';
          } else {
            if (target) target.style.cursor = 'default';
          }
        }
      }
    });
  }

  // To get the groups
  getGroups() {
    if (!this.groups.length) {
      let allGroupsOption = {"name": "All", "groupId":"All"};
      this.groupsService.getGroupsWithoutAssignedDevicesCount().subscribe(res => {
        this.groups = res;
        this.groups.unshift(allGroupsOption);
        this.selectedCategory = "groupName";
        this.displayCategory = res[0].name;
        this.onTimeChange(null);
      }, error => {
        this.sharedService.getErrorMsg(error);
      });
    }
  }

  sumCountsByDay(dataSets: any[]) {
    const sumByDayMap = new Map<number, number>();
  
    dataSets.forEach(dataSet => {
      dataSet.data.forEach((item: { day: number; count: number }) => {
        const currentCount = sumByDayMap.get(item.day) || 0;
        sumByDayMap.set(item.day, currentCount + item.count);
      });
    });
  
    // Convert the map back to an array if needed
    return Array.from(sumByDayMap, ([day, count]) => ({ day, count }));
  }

}
